import 'UI/Widget/Text'
import 'UI/Widget/Forms/Control/Input'

/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Input
 */
UI.Widget.Forms.Control.Text = Class(UI.Widget.Forms.Control.Input, /** @lends UI.Widget.Forms.Control.Text.prototype */ {
    textControl: null,

    createElement: function() {
        this.$element = $("<input type='text'>");

        if (this.disabled) {
            this.$element.prop("disabled", true);
        }
    },

    insertElement: function() {
        var self = this;

        this.ParentCall();

        this.textControl = new UI.Widget.Text(this.parent, {
            element: this.$element.is('input') ? this.$element : this.$element.find('input[type=text]')
        });

        var onLiveChange = this.$control.attr("on-live-change");

        if (onLiveChange) {
            this.textControl.liveChange().on("livechange", function(args) {
                if (self.parent && Util.isFunction(self.parent[onLiveChange])) {
                    self.parent[onLiveChange](args);
                }
            });
        }

        var mask = this.$control.attr("mask");

        if (mask) {
            this.$element.mask(mask);
        }
    },

    removeElement: function() {
        this.textControl.unlink();
        this.textControl.destroy();

        this.textControl = null;

        this.ParentCall();
    },
});
